module.exports = __webpack_public_path__ + "static/media/star_review_active_ic.e25a85c5.svg";